import { Minus } from 'lucide-react';
import type { DividerBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const dividerConfig: BlockTypeConfig<DividerBlock> = {
  type: 'divider',
  label: 'Divider',
  description: 'Visual separator between sections',
  icon: Minus,
  category: 'layout',
  createDefault: () => ({
    style: 'line',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.style',
      label: 'Style',
      options: [
        { value: 'line', label: 'Line' },
        { value: 'dots', label: 'Dots' },
        { value: 'space', label: 'Space' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  variants: [
    {
      id: 'default',
      label: 'Line',
      thumbnail: '/admin/page-editor/variants/divider-default.svg',
      apply: (d) => ({ ...d, variant: 'default', style: 'line' }),
    },
    {
      id: 'wave',
      label: 'Wave',
      thumbnail: '/admin/page-editor/variants/divider-wave.svg',
      apply: (d) => ({ ...d, variant: 'wave' }),
    },
    {
      id: 'gradient-fade',
      label: 'Gradient fade',
      thumbnail: '/admin/page-editor/variants/divider-gradient-fade.svg',
      apply: (d) => ({ ...d, variant: 'gradient-fade' }),
    },
  ],
  sheet: [],
};
